import { Table } from "@/features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type S3StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterS3StaticDatumsSchema,
  FilterS3StaticDatums,
} from "./filter";

export const S3StaticDatumsTable = () => {
  return (
    <Table<S3StaticDatum, FilterS3StaticDatumsSchema>
      label="Actifs"
      client={Clients.S3}
      table_name={Tables.S3_STATIC_DATA}
      columns={porfolios_columns}
      filter={<FilterS3StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.S3}/${Tables.S3_STATIC_DATA}/new`,
        },
      ]}
    />
  );
};
